export default {
  'header': {
    'hideMenuBar': 'Masquer la barre de menu',
    'showMenuBar': 'Afficher la barre de menu'
  }
}
